import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "rgb(var(--color-reference-platform-brand))",
      d: "m401-130-95-176-176-95 67-68 145 25 97-96-309-133 85-85 372 69 120-120q21-21 51-21t51 21 21 50.5-21 50.5L689-588l69 373-85 85-133-309-96 97 25 145z"
    }, null, -1)
  ])))
}
export default { render: render }